export namespace Enums {
    export enum Messages {
        GeneralError = 'Erro ao executar a operação (FE01)',
        GeneralErrorInterceptor = 'Erro ao executar a operação (FE07)',
        AcessoCidadaoExpiredWarningReload = `Sessão inválida do Acesso Cidadão. Recarregue a página ou acesse o E-Flow em outra aba para renovar a sessão
            automaticamente ou realizar o login, caso seja necessário`,
        AccessDenied = 'Acesso Negado',
        NoAccessToResource = 'Você não possui acesso a esse recurso',
        MyNewFlow = 'Meu Novo Fluxo',
        Error = 'Erro',
        Pendency = 'Pendência',
        Warning = 'Alerta',
        Success = 'Sucesso',
        Form = 'Formulário',
        Information = 'Informação',
        SendButtonText = 'Prosseguir',
        LandlinePhoneText = 'Fixo',
        PageTitleEFlow = 'E-Flow',
        PageTitleConectaEs = 'Conecta ES',
        EnvironmentLocalhost = 'Localhost',
        EnvironmentDevelopment = 'Desenvolvimento',
        EnvironmentStaging = 'Homologação',
        EnvironmentLearning = 'Treinamento',
        NoFlowStarterError = 'Não foi encontrada Tarefa Inicial para o Fluxo especificado',
        FormSubmitSuccess = 'Formulário submetido.',
        FormSubmitError = 'Erro ao submeter formulário.',
        MessageFieldMandatory = 'O campo "Mensagem" é obrigatório',
        AttachmentMandatory = 'Todos os anexos configurados na Tarefa são de fornecimento obrigatório',
        PdfFilesOnly = 'Apenas arquivos com extensão PDF são permitidos',
        PdfMaxSizeLimit = 'O tamanho do arquivo PDF deve ser menor que {0}MB',
        MinioPostError = 'Erro HTTP {0}: {1}',
        InvalidIcpBrasil = 'Assinatura ICP-Brasil inválida para o documento anexado no campo "{0}"',
        InvalidEDocsDocument = 'O documento anexado no campo "{0}" não pode ser capturado no E-Docs. Motivo: "{1}"',
        NoSignerIdError = 'Selecione um papel antes de prosseguir com o envio do conteúdo',
        MjolnirProceedError = 'Não é possível prosseguir com a execução deste Fluxo',
        SearchMinLength = 'Insira um mínimo de 3 caracteres',
        Citizen = 'CIDADÃO',
        FinalPreviewDialogTitle = 'Pré-visualizar documento',
        FinalPreviewDialogMessage = `O PDF disponibilizado a seguir é uma pré-visualização do documento que será capturado no E-Docs a partir do envio do
            formulário. Note que apenas <b>após</b> a confirmação do envio será gerada a versão final do documento — isto é, sem a marca d'água de <b>RASCUNHO</b>.
            <br><br>Deseja prosseguir para a pré-visualização do documento?`,
        ConfirmEnqueueTask = 'Deseja enfileirar a Tarefa novamente para execução?',
        ConfirmFinishTask = 'Deseja encerrar com sucesso tanto a Tarefa quanto o Fluxo?',
        ConfirmCancelTask = 'Deseja cancelar a Tarefa e, consequentemente, esta instância de Fluxo?',
        ConfirmExecuteTask = 'Deseja prosseguir com a execução desta Tarefa?',
        ConfirmSendForm = 'Deseja prosseguir com o envio dos dados do formulário?',
        ConfirmRemoveFile = 'Deseja remover o arquivo adicionado?',
        ConfirmCancelByDeliberation = 'Deseja cancelar esta instância de Fluxo manualmente?',
        MessageMinlengthError = 'Forneça uma mensagem com no mínimo 5 caracteres',
        MissingAttachmentsError = 'Forneça todos os anexos esperados na configuração da Tarefa',
        ForwardingProtocolMissingError = 'Erro ao recuperar o protocolo de Encaminhamento E-Docs do Fluxo',
        RequiredFilesPendency = 'Os seguintes campos de anexos obrigatórios não foram preenchidos: {0}',
        EDocsProtocolDocumentsPendency = 'Você não possui permissão de uso dos documentos E-Docs referentes aos seguintes protocolos: "{0}"',
        EDocsProtocolNotFound = 'O seguinte protocolo de Documento E-Docs não foi encontrado: "{0}"',
        ProcessNotFoundError = 'Não foi possível localizar o processo com o protocolo informado',
        FormDataLoadError = 'Erro ao recuperar os dados do formulário respondido pelo solicitante',
        FieldKeyLoadError = 'Erro ao recuperar a chave do campo do formulário configurado para conter o protocolo do Processo a ser entranhado',
        UnfinishedFileUploads = 'Aguardando o término do upload de todos os arquivos',
        FormDraftRecovered = 'Rascunho do formulário recuperado com sucesso',
        FormDraftCleared = 'Rascunho do formulário descartado com sucesso',
        MjolnirSuccess = 'Operação executada com sucesso',
        DefaultEmptyValue = '(N/D)',
        DefaultLoadingText = 'Carregando...',
        AutomaticallyCancelledFinisherInfo = 'SISTEMA',
        CpfCheckError = '(Mensagem do Acesso Cidadão) Erro ao verificar o CPF {0}',
        AcApiError = 'Erro na comunicação com a API do Acesso Cidadão',
        EDocsApiTimeoutMessage = `Tempo de espera esgotado ao tentar estabelecer comunicação com o E-Docs.
            <br><br>Caso o formulário possua anexos, é possível que ao menos um dos documentos esteja encontrando dificuldades para ser capturado no E-Docs
            em função de problemas estruturais no PDF — infelizmente, para esse tipo específico de problema, o E-Docs não nos informa quais seriam os
            documentos afetados.
            <br><br>Para corrigir um PDF nessas condições, abra-o no navegador Chrome e selecione a opção para imprimir o documento; em seguida, salve-o
            como um novo PDF e utilize este último como anexo do formulário. Esse procedimento pode ser realizado em todos os PDFs que não tenham assinatura
            digital prévia — mas apenas nestes, uma vez que o processo remove assinaturas digitais do documento.
            <br><br>Caso necessite identificar exatamente quais documentos possuem o referido problema no PDF, acesse o E-Docs no
            <a href="https://treinamento.e-docs.es.gov.br/documento/captura/pdf" target="_blank">ambiente de treinamento</a>, tente capturar os PDFs por lá
            e identifique aqueles que não sejam capturados em poucos segundos (não haverá mensagem de erro; o documento entrará na fila para captura posterior
            mas de lá nunca sairá).`,
    }

    export enum Profiles {
        Administrator = 'Administrador',
        AdminAll = 'AdminAll',
        Owner = 'Owner',
        ErrorPage = 'ErrorPage'
    }

    export enum GatewayPathsLabels {
        True = 'Sim',
        False = 'Não'
    }

    export enum PagesPaths {
        FlowDefinitionList = '/flow-definition-list',
        FlowInstanceList = '/flow-instance-list',
        FlowDefinition = '/flow-definition',
        FlowInstance = '/flow-instance',
        FlowInstanceResult = '/flow-instance-result',
        CatalogService = '/service',
        Home = '/',
        Tests = '/tests',
        Mjolnir = '/mjolnir',
        Error = '/error',
        Eula = '/eula',
        LoadingPage = '/ldp',
        Embedded = '/ebd',
        Edocs = '/edc',
        Origin = '/origem',
    }

    export enum SortField {
        CreateDate = 'CreateDate',
        UpdateDate = 'UpdateDate',
        Name = 'Name',
        OwnerInfo = 'OwnerInfo'
    }

    export enum PredefinedFilter {
        Finished = 10,
        Ongoing = 11,
        Cancelled = 12,
        StartedByMe = 20,
        NotStartedByMe = 21,
        PendingForMe = 30,
        NotPendingForMe = 31
    }

    export const PredefinedFilterDescription = new Map<number, string>([
        [PredefinedFilter.Finished, 'Encerrados'],
        [PredefinedFilter.Ongoing, 'Em andamento'],
        [PredefinedFilter.Cancelled, 'Cancelados'],
        [PredefinedFilter.StartedByMe, 'Iniciados por mim'],
        [PredefinedFilter.NotStartedByMe, 'Iniciados por outros'],
        [PredefinedFilter.PendingForMe, 'Com pendências para mim'],
        [PredefinedFilter.NotPendingForMe, 'Sem pendências para mim']
    ]);

    export const PredefinedFilterKey = new Map<number, string>([
        [PredefinedFilter.Finished, '{|_Finished_|}'],
        [PredefinedFilter.Ongoing, '{|_Ongoing_|}'],
        [PredefinedFilter.Cancelled, '{|_Cancelled_|}'],
        [PredefinedFilter.StartedByMe, '{|_StartedByMe_|}'],
        [PredefinedFilter.NotStartedByMe, '{|_NotStartedByMe_|}'],
        [PredefinedFilter.PendingForMe, '{|_PendingForMe_|}'],
        [PredefinedFilter.NotPendingForMe, '{|_NotPendingForMe|}']
    ]);

    export enum LocationType {
        Unit = 0,
        Organization = 1,
        Patriarch = 2
    }

    export enum ProcessOrigin {
        Instance = 1,
        PublicAgentDeliberation = 2,
        Form = 3
    }

    export enum ProcessStatus {
        EmAndamento = 1,
        Encerrado = 2,
        Sobrestado = 3
    }

    export enum ProcessStatusLabel {
        EmAndamento = 'EmAndamento',
        Encerrado = 'Encerrado',
        Sobrestado = 'Sobrestado'
    }
}
